
import React from 'react';
import { motion } from 'framer-motion';

interface XpProgressBarProps {
    currentXp?: number;
    nextLevelXp?: number;
    progress: number;
    className?: string;
    showText?: boolean;
    size?: 'sm' | 'md' | 'lg';
}

export const XpProgressBar: React.FC<XpProgressBarProps> = ({ progress, className = '', showText = true, size = 'md' }) => {
    const heightClass = {
        sm: 'h-1.5',
        md: 'h-2.5',
        lg: 'h-4',
    }[size];

    return (
        <div className={`w-full flex flex-col gap-1 ${className}`}>
            <div className={`w-full bg-gray-700/50 rounded-full overflow-hidden backdrop-blur-sm border border-white/5 ${heightClass}`}>
                <motion.div
                    className="h-full bg-gradient-to-r from-orange-500 via-orange-600 to-orange-500 shadow-[0_0_10px_rgba(249,115,22,0.4)]"
                    initial={{ width: 0 }}
                    animate={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
                    transition={{ duration: 1, ease: "easeOut" }}
                />
            </div>
            {showText && (
                <div className="flex justify-between text-[10px] text-gray-400 font-medium px-0.5">
                    <span>XP</span>
                    <span>{Math.round(progress)}%</span>
                </div>
            )}
        </div>
    );
};
